module.exports = __webpack_public_path__ + "img/Newbie_Staff_01_Classic.5f991c0b.png";